import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import getLogin from "../../services/login/getLogin";

const LoginForm = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const [user, setUser] = useState("")
    const [pass, setPass] = useState("")
    const [error, setError] = useState("")
    const [msg, setMsg] = useState("")

    useEffect(() => {
        return () => {

        };
    }, [msg, navigate]);

    const handleInputChange = (e, type) => {
        const value = e.target.value
        setError(undefined)
        if (type === "user") {
            setUser(value)
        } else if (type === "pass") {
            setPass(value)
        }
    }

    const loginSubmit = (e) => {
        e.preventDefault()
        if (user !== "" && pass !== "") {
            getLogin(user, pass)
                .then((data) => {
                    if (data["mensaje"] === "LOGIN_ERROR") {
                        setError("Datos incorrectos.")
                    }
                    else if (data["mensaje"] === "LOGIN_OK") {
                        setMsg("Ok !")
                        localStorage.setItem("login", "true")
                        localStorage.setItem("nombre_usuario", data["nombre"])
                        localStorage.setItem("red_asistencial", data["red_asistencial"])
                        localStorage.setItem("perfil", data["perfil"])
                        localStorage.setItem("token", data["token"])
                        
                        if (location.pathname === "/") {
                            navigate("/dashboard")
                        }
                        else {
                            navigate(0)
                        }
                    }
                    else {
                        setError("Ocurrió un problema (" + data + ")")
                    }
                })
                .catch((err) => {
                    setError("Error de Servidor:" + err.message)
                })
        }
        else {
            setError("Todos los campos son requeridos.")
        }
    }

    return (
        <div className="row">
            <div className="col-sm-4 offset-sm-4">
                <div className="mt-5">
                    <div className="card card-outline card-cyan">
                        <div className="card-header text-center text-info">
                            <span className="h1"><i className="nav-icon fas fa-user-astronaut"></i></span>
                            <span className="h2 text-bold"> Sisweb</span>
                        </div>
                        <div className="card-body">
                            <form onSubmit={loginSubmit} name='login'>
                                <p className="login-box-msg">Ingresar al Sistema</p>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" placeholder="Documento de Identidad" value={user} onChange={(e) => handleInputChange(e, "user")} name="user" />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-id-card"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group mb-3">
                                    <input type="password" className="form-control" placeholder="Contraseña" value={pass} onChange={(e) => handleInputChange(e, "pass")} name="pass" />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-lock"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <button type="submit" className="btn btn-info btn-block">Ingresar</button>
                                        <p className='pt-4'>
                                            {
                                                (error) && <span className='text-danger text-center'>{error}</span>
                                            }
                                            {
                                                (msg) && <span className='text-success text-center h5'> <span className="fas fa-check-circle"></span> {msg}</span>
                                            }

                                        </p>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LoginForm